module.exports = __webpack_public_path__ + "static/media/joker-card.1dc17482.wav";